import {
  OVERVIEW_ACTIVE,
  OVERVIEW_INACTIVE,
  FOLDER_ACTIVE,
  FOLDER_INACTIVE,
  REQUEST_ACTIVE,
  REQUEST_INACTIVE,
  PAYMENT_ACTIVE,
  PAYMENT_INACTIVE,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_INACTIVE,
  SETTING_ACTIVE,
  SETTING_INACTIVE,
} from "../../../../assets";

export const PrivateIndividualSidebarRoute = [
  {
    title: "Overview",
    activeIcon: OVERVIEW_ACTIVE,
    inactiveIcon: OVERVIEW_INACTIVE,
    path: "/private-individual/overview",
  },
  {
    title: "Case Folders",
    activeIcon: FOLDER_ACTIVE,
    inactiveIcon: FOLDER_INACTIVE,
    path: "/private-individual/case-folders",
  },
  {
    title: "Request",
    activeIcon: REQUEST_ACTIVE,
    inactiveIcon: REQUEST_INACTIVE,
    path: "/private-individual/request",
  },
  {
    title: "Payment history",
    activeIcon: PAYMENT_ACTIVE,
    inactiveIcon: PAYMENT_INACTIVE,
    path: "/private-individual/payment-history",
  },
  {
    title: "Notification",
    activeIcon: NOTIFICATION_ACTIVE,
    inactiveIcon: NOTIFICATION_INACTIVE,
    path: "/private-individual/notification",
  },
  {
    title: "Setting",
    activeIcon: SETTING_ACTIVE,
    inactiveIcon: SETTING_INACTIVE,
    path: "/private-individual/setting",
  },
];
